import { TrackDonateFormOptions } from './types'
import { dataLayer } from 'shared'

export const trackDonateFormVisit = ({ config, display }: TrackDonateFormOptions) => {
  dataLayer.push({
    event: 'eeCheckout',
    ecommerce: {
      currencyCode: 'EUR',
      checkout: {
        actionField: { step: 1, option: 'form loaded' },
        products: [
          {
            name: escapeHTML(display.receiverName),
            id: `${config.receiverType}#${config.receiverId}`,
            brand: display.receiverGtmBrand,
            quantity: 1,
          },
        ],
      },
    },
  })
}

// slim and temple did _some_ escaping to the ecommerce javascript. Since we
// use the receiverName to aggregate results we need to mirror that exact
// behavior.
// See https://github.com/judofyr/temple/blob/master/lib/temple/utils.rb#L42-L49
const escapeHTML = (value: string): string =>
  value.replace('&', '&amp;').replace('"', '&quot;').replace("'", '&#39;').replace('<', '&lt;').replace('>', '&gt;')
